<template>
  <li class="menu-item">
    <a href="#" @click.stop="click" :title="drawMode !== 'draw' ? 'Velg tegneverktøy' : 'Gå ut av tegnemodus'" :class="drawMode === 'draw' ? 'active' : ''"><t-icon :name="`icon-${tool}`" /></a>
    <ul class="sub-menu-items" :style="submenuStyle">
      <li class="sub-menu-item" title="Viskelær"><a href="#" @click.prevent="setTool('eraser')"><t-icon name="icon-eraser" /></a></li>
      <li class="sub-menu-item" title="Bred tusj"><a href="#" @click.prevent="setTool('marker')"><t-icon name="icon-marker" /></a></li>
      <li class="sub-menu-item" title="Smal tusj"><a href="#" @click.prevent="setTool('edit')"><t-icon name="icon-edit" /></a></li>
    </ul>
  </li>
</template>

<script>
import MenuItem from './MenuItem'
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      open: false
    }
  },
  methods: {
    ...mapActions(['setDrawMode']),
    ...mapActions({ vuexSetTool: 'setTool' }),
    setTool (tool) {
      this.vuexSetTool(tool)
      this.setDrawMode('draw')
      this.open = !this.open
    },
    click (event) {
      event.preventDefault()
      if (this.drawMode === 'draw') {
        this.setDrawMode('view')
      } else {
        this.open = !this.open
      }
    }
  },
  computed: {
    ...mapGetters(['tool', 'drawMode']),
    submenuStyle () {
      return {
        'min-width': `${3 * 55}px`
      }
    }
  },
  watch: {
    open (newVal) {
      this.$el.classList.toggle('open')
    }
  },
  components: {
    MenuItem
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/MenuItemEdit.vue